import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Routes from './routes/index';
import { AuthProvider } from "./context/AuthContext";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
    <Routes />
    </AuthProvider>
  </React.StrictMode>
);